import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Sparkles } from 'lucide-react';
const forYou = ['Querés empezar a vender iPhones y no sabés cómo conseguir clientes.', 'Ya vendés iPhones, pero dependés del boca en boca o de subir historias todos los días.', 'Tenés una tienda y recibís muchas consultas, pero pocas personas realmente compran.', 'Tenés stock pero te cuesta moverlo y no sabés qué modelo conviene anunciar.', 'Ya probaste anuncios pero te llegaron malos leads o sentís que perdiste plata.', 'Querés aprender a crear anuncios en Instagram y Meta Ads sin depender de una agencia.'];
const notForYou = ['Buscás resultados mágicos o leads baratos garantizados.', 'Querés un curso técnico avanzado de Meta Ads.', 'Buscás una guía genérica de marketing digital.', 'No tenés intención de mejorar tus ofertas, anuncios y atención comercial.', 'Querés copiar campañas sin entender por qué funcionan.'];
const bestFit = ['Personas que entienden el negocio iPhone (o están dispuestas a entenderlo) y quieren un sistema claro para conseguir conversaciones de calidad.', 'Vendedores y tiendas que ya tienen stock o capacidad de conseguirlo, y necesitan dejar de depender solo del orgánico.', 'Emprendedores que valoran aplicar paso a paso antes de buscar resultados.'];
export function WhoFor() {
  return <section className="py-20 md:py-32 bg-zinc-50" data-id="element-317">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-319">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-4" data-id="element-320">
            ¿Para quién es esta guía?
          </h2>
          <p className="text-lg text-zinc-600 text-balance" data-id="element-321">
            Sistema iPhone Ads está pensada para personas que venden o quieren
            vender iPhones por Instagram y mensajes — no para marketers
            genéricos ni para expertos técnicos en Meta Ads.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-8" data-id="element-322">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-zinc-200" data-id="element-323">
            <div className="flex items-center gap-2 mb-6" data-id="element-324">
              <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-325">
                <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-326" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-zinc-900" data-id="element-327">
                Esta guía es para vos si…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-328">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-329">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-330" />
                  <span className="text-zinc-700 leading-relaxed" data-id="element-331">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-zinc-100 rounded-3xl p-8 md:p-10 border border-zinc-200" data-id="element-332">
            <div className="flex items-center gap-2 mb-6" data-id="element-333">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-334">
                <XCircle className="w-5 h-5 text-red-600" data-id="element-335" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-zinc-900" data-id="element-336">
                Esta guía no es para vos si…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-337">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-338">
                  <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-339" />
                  <span className="text-zinc-600 leading-relaxed" data-id="element-340">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Best fit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.25
      }} className="bg-blue-600 text-white rounded-3xl p-8 md:p-10" data-id="element-341">
          <div className="flex items-center gap-2 mb-5" data-id="element-342">
            <Sparkles className="w-5 h-5 text-blue-200" data-id="element-343" />
            <h3 className="text-xl md:text-2xl font-bold" data-id="element-344">
              Quién le saca más provecho
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-345">
            {bestFit.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-346">
                <span className="block w-1.5 h-1.5 rounded-full bg-blue-200 mt-2.5 shrink-0" data-id="element-347" />
                <span className="text-blue-50 leading-relaxed" data-id="element-348">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}